/**
 * KPI 관련 GraphQL 쿼리
 */

/**
 * 통합 대시보드 데이터 조회 쿼리
 */
export const GET_DASHBOARD_DATA = `
  query getDashboardData($filter: DashboardFilter!) {
    getDashboardData(filter: $filter) {
      kpiData {
        kpiIndicatorCd
        kpiTitle
        categoryCd
        categoryNm
        chartType
        unit
        targetType
        targetValue
        currentValue
        chartData
        __typename
      }
      performanceData {
        overallAverageAchievementRate
        branchPosition
        weeklyTrend {
          date
          isHoliday
          transmittedKpiData {
            site
            compCd
            kpiIndicatorCd
            kpiIndicatorNm
            categoryCd
            categoryNm
            measuredValue
            currentValue
            targetValue
            achievementRate
            targetType
            unit
            transmitCycle
            transmissionDate
            __typename
          }
          __typename
        }
        __typename
      }
      heatmapData {
        date
        dailyTotalPower
        dailyAvgPower
        dailyMaxPower
        deviceCount
        __typename
      }
      __typename
    }
  }
`;

/**
 * 구독 중인 KPI 지표 데이터 조회 쿼리 (지표별 필터 지원)
 * 각 KPI 지표에 대한 차트 데이터를 개별 필터로 조회
 */
export const GET_KPI_CHART_DATA = `
  query getKpiChartData($filters: [KpiSubscriptionFilter!]!) {
    getKpiChartData(filters: $filters) {
      kpiIndicatorCd
      kpiTitle
      categoryCd
      categoryNm
      chartType
      unit
      targetType
      targetValue
      currentValue
      chartData
      __typename
    }
  }
`;


/**
 * 지부장이 선택한 회사의 KPI 지표 데이터 조회 쿼리 (지표별 필터 지원)
 * 각 KPI 지표에 대한 차트 데이터를 개별 필터로 조회
 */
export const GET_KPI_CHART_DATA_BY_SITE_AND_COMP_CD = `
  query getKpiChartDataBySiteAndCompCd($filters: [KpiSubscriptionFilterWithSiteAndCompCd!]!) {
    getKpiChartDataBySiteAndCompCd(filters: $filters) {
      kpiIndicatorCd
      kpiTitle
      categoryCd
      categoryNm
      chartType
      unit
      targetType
      targetValue
      chartData
      __typename
    }
  }
`;


// else{
//     const query =
//         `query getSelectedCompanyRealPowerData ($filters: []!) {
//                 getSelectedCompanyRealPowerData (filters: $filters) {
//                   timeLabel
//                   label
//                   value
//               }
//             }`;
// }


/**
 * 구독 중인 KPI 지표 데이터 조회 쿼리 (지표별 필터 지원)
 * 각 KPI 지표에 대한 차트 데이터를 개별 필터로 조회
 */
export const GET_KPI_SITE_DATA = `
  query getKpiSiteData($filters: [KpiSubscriptionFilter!]!) {
    getKpiSiteData(filters: $filters) {
      kpiIndicatorCd
      kpiTitle
      categoryCd
      categoryNm
      chartType
      unit
      targetType
      targetValue
      chartData
      __typename
    }
  }
`;


/**
 * 각 회사의 KPI 지표 데이터
 */
export const GET_KPI_SITE_COMPANY_DATA = `
  query getKpiSiteCompanyData($filters: [KpiSubscriptionFilter!]!) {
    getKpiSiteCompanyData(filters: $filters) {      
      compCd
      companyName
      aggregationDate
      kpiIndicatorCd
      kpiIndicatorNm
      unit
      categoryCd
      categoryNm
      currentValue
      targetValue
      targetType
      __typename
    }
  }
`;



/**
 * 각 회사의 KPI 지표 데이터
 */
export const GET_KPI_SITE_COMPANY_DOUGHNUT_CHART_DATA = `
  query getKpiSiteCompanyDoughnutChartData($filters: [KpiSubscriptionFilter!]!) {
    getKpiSiteCompanyDoughnutChartData(filters: $filters) {      
      compCd
      companyName
      kpiIndicatorNm
      unit
      currentValue
      targetValue
    }
  }
`;


// /**
//  * 각 회사의 KPI 달성률 막대 비교 데이터
//  */
// export const GET_KPI_SITE_COMPANY_BAR_CHART_DATA = `
//   query getKpiSiteCompanyBarChartData($filters: [KpiSubscriptionFilter!]!) {
//     getKpiSiteCompanyBarChartData(filters: $filters) {
//       compCd
//       companyName
//       aggregationDate
//       kpiIndicatorCd
//       kpiIndicatorNm
//       unit
//       categoryCd
//       currentValue
//       targetValue
//     }
//   }
// `;


/**
 * 각 회사의 KPI 달성률 막대 비교 데이터 - avg 포함
 */
export const GET_KPI_SITE_COMPANY_BAR_CHART_DATA = `
  query getKpiSiteCompanyBarChartData($filters: [KpiSubscriptionFilter!]!) {
    getKpiSiteCompanyBarChartData(filters: $filters) {      
      compCd
      companyName
      kpiIndicatorCd
      kpiIndicatorNm
      unit
      categoryCd
      avgCurrentValue
      targetValue
      targetType
    }
  }
`;


/**
 * KPI 필터 타입 정의
 * @typedef {Object} KpiFilter
 * @property {string} date - 기준 날짜
 * @property {string} range - 데이터 범위 (day, week, month)
 */

/**
 * KPI 지표별 필터 타입 정의
 * @typedef {Object} KpiSubscriptionFilter
 * @property {string} [kpiIndicatorCd] - KPI 지표 코드 (생략 시 사용자의 모든 구독 지표에 적용)
 * @property {string} [categoryCd] - KPI 카테고리 코드 (생략 시 사용자의 모든 구독 지표에 적용)
 * @property {string} date - 기준 날짜
 * @property {string} range - 데이터 범위 (day, week, month)
 */

/**
 * KPI 차트 데이터 타입 정의
 * @typedef {Object} KpiChartData
 * @property {string} kpiIndicatorCd - KPI 지표 코드
 * @property {string} kpiTitle - KPI 지표 제목
 * @property {string} categoryCd - 카테고리 코드
 * @property {string} categoryNm - 카테고리 이름
 * @property {string} chartType - 차트 타입 (line, bar 등)
 * @property {string} unit - 단위
 * @property {number} targetValue - 목표값
 * @property {Array<Object>} chartData - 차트 데이터
 */
